import IvoIcon from '../../../../../assets/image/shop/ivo.svg';
import DoeIcon from '../../../../../assets/image/shop/doe.svg';
import InsoIcon from '../../../../../assets/image/shop/inso.svg';
import FdaIcon from '../../../../../assets/image/shop/fda.svg';
import IsoIcon from '../../../../../assets/image/shop/iso.svg';
import UtIcon from '../../../../../assets/image/shop/ut.svg';
import PlantIcon from '../../../../../assets/image/shop/plant.svg';
import WaterAndSoilIcon from '../../../../../assets/image/shop/soil.svg';
import LivestockIcon from '../../../../../assets/image/shop/cow.svg';
import FertilizerIcon from '../../../../../assets/image/shop/fertilizer.svg';

export const LabCertificates: Array<ILabCertificate> = [
  {
    code: 1,
    title: 'دام پزشکی',
    id: 'ivo',
    icon: IvoIcon,
  },
  {
    code: 2,
    title: 'محیط زیست',
    id: 'deo',
    icon: DoeIcon,
  },
  {
    code: 3,
    title: 'سازمان ملی استاندارد',
    id: 'InsoIcon',
    icon: InsoIcon,
  },
  {
    code: 4,
    title: 'غذا و دارو',
    id: 'fda',
    icon: FdaIcon,
  },
  {
    code: 5,
    title: 'استاندارد',
    id: 'iso',
    icon: IsoIcon,
  },
  {
    code: 6,
    title: 'دانشگاه تهران',
    id: 'ut',
    icon: UtIcon,
  },
];

export const LabActivities: ILabActivity[] = [
  {
    icon: PlantIcon,
    id: 'PLANT',
    title: 'گیاه',
    code: 12,
  },
  {
    icon: WaterAndSoilIcon,
    id: 'WATER_AND_SOIL',
    title: 'آب و خاک',
    code: 11,
  },
  {
    icon: LivestockIcon,
    id: 'LIVESTOCK ',
    title: 'دام',
    code: 14,
  },
  {
    icon: FertilizerIcon,
    id: 'FERTILIZER',
    title: 'کود',
    code: 13,
  },
];
